/* KAELA clone — product page: bundle deal picker + quantity selector */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    var qtyInput = document.querySelector("[data-qty-input]");

    /* ---------- Bundle deal picker ---------- */

    document.querySelectorAll("[data-bundle]").forEach(function (bundle) {
      var bars = bundle.querySelectorAll("[data-bundle-bar]");

      /* L abonnement ne recalcule rien : chaque palier porte deja ses deux prix
         formates par Liquid, on ne fait que choisir lequel est affiche. Appele
         au debut de sync() pour que la barre collante, qui recopie le texte du
         palier selectionne juste apres, lise la bonne valeur. */
      function applySubPricing() {
        var subInput = document.querySelector("[data-sub-input]");
        var on = !!(subInput && subInput.checked);
        bars.forEach(function (bar) {
          var target = bar.querySelector("[data-bundle-price]");
          var sub = bar.getAttribute("data-price-sub");
          var one = bar.getAttribute("data-price-oneshot");
          if (target && sub && one) target.textContent = on ? sub : one;

          /* Le badge d economie se calcule sur le prix barre ET sur le prix
             affiche : le laisser sur la valeur hors abonnement annoncerait
             « economisez 83,35 € » au-dessus d un prix qui en economise 100,01. */
          var badge = bar.querySelector("[data-bundle-save]");
          if (badge) {
            var bSub = badge.getAttribute("data-badge-sub");
            var bOne = badge.getAttribute("data-badge-oneshot");
            if (bSub && bOne) badge.textContent = on ? bSub : bOne;
          }
        });
      }

      function sync() {
        applySubPricing();
        var selectedTier = 1;
        bars.forEach(function (bar) {
          var input = bar.querySelector(".pm-bundle-input");
          var checked = input && input.checked;
          bar.classList.toggle("selected", !!checked);
          if (checked && qtyInput) {
            qtyInput.value = parseInt(bar.getAttribute("data-buy-qty"), 10) || 1;
          }
          if (checked) {
            selectedTier = parseInt(bar.getAttribute("data-tier"), 10) || 1;
            var selectedPrice = bar.querySelector("[data-bundle-price]");
            var selectedCompare = bar.querySelector("[data-bundle-compare]");
            document.querySelectorAll("[data-atc-price], [data-sticky-price]").forEach(function (el) {
              if (selectedPrice) el.textContent = selectedPrice.textContent.trim();
            });
            document.querySelectorAll("[data-sticky-compare]").forEach(function (el) {
              if (selectedCompare) {
                el.textContent = selectedCompare.textContent.trim();
                el.hidden = false;
              } else {
                el.hidden = true;
              }
            });
          }
        });

        bundle.setAttribute("data-selected-tier", String(selectedTier));
        bundle.querySelectorAll("[data-unlock-tier]").forEach(function (gift) {
          var unlockTier = parseInt(gift.getAttribute("data-unlock-tier"), 10) || 1;
          var unlocked = selectedTier >= unlockTier;
          var wasUnlocked = gift.classList.contains("is-unlocked");

          if (unlocked) {
            if (!wasUnlocked) {
              gift.classList.remove("is-unlocked");
              void gift.offsetWidth;
              gift.classList.add("is-unlocked");
            }
          } else {
            gift.classList.remove("is-unlocked");
          }

          gift.setAttribute("aria-label", unlocked ? "Cadeau inclus dans le pack sélectionné" : "Cadeau disponible à partir du pack " + unlockTier);
        });
      }

      bundle.addEventListener("change", function (e) {
        if (e.target.classList.contains("pm-bundle-input")) sync();
      });

      var subToggle = document.querySelector("[data-sub-input]");
      if (subToggle) subToggle.addEventListener("change", sync);

      sync(); // initial state (radio "checked" in HTML)
    });

    /* ---------- Quantity +/- ---------- */

    document.querySelectorAll("[data-qty-minus], [data-qty-plus]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (!qtyInput) return;
        var v = parseInt(qtyInput.value, 10) || 1;
        v += btn.hasAttribute("data-qty-plus") ? 1 : -1;
        qtyInput.value = Math.max(1, v);
      });
    });

    /* ---------- FAQ accordion (Description / Mode d'emploi / ...) ---------- */

    document.querySelectorAll("[data-faq] .pm-faq-item").forEach(function (item) {
      var question = item.querySelector(".pm-faq-question");
      if (!question) return;

      question.addEventListener("click", function () {
        var faq = item.closest("[data-faq]");
        var wasOpen = item.classList.contains("active");

        faq.querySelectorAll(".pm-faq-item.active").forEach(function (open) {
          open.classList.remove("active");
        });

        if (!wasOpen) item.classList.add("active");
      });
    });

    /* ---------- Store FAQ accordion (Questions fréquentes) ---------- */

    document.querySelectorAll("[data-accordion] .faq-item").forEach(function (item) {
      var question = item.querySelector(".faq-question");
      if (!question) return;

      question.addEventListener("click", function () {
        var container = item.closest("[data-accordion]");
        var wasOpen = item.classList.contains("active");

        container.querySelectorAll(".faq-item.active").forEach(function (open) {
          open.classList.remove("active");
        });

        if (!wasOpen) item.classList.add("active");
      });
    });

    /* ---------- Reviews carousel arrows ---------- */

    var reviewsContainer = document.querySelector(".reviews-container");
    if (reviewsContainer) {
      /* Le pas se mesure sur la carte au moment du clic : sa largeur est
         responsive (min(300px, 100vw - 72px)), un pas en dur decalait le
         rail de plus en plus a chaque fleche. */
      var pasCarrousel = function () {
        var carte = reviewsContainer.querySelector(".review-card");
        if (!carte) {
          return parseInt(reviewsContainer.getAttribute("data-scroll-amount"), 10) || 360;
        }
        var gap = parseFloat(getComputedStyle(reviewsContainer).columnGap) || 0;
        return carte.getBoundingClientRect().width + gap;
      };

      document.querySelectorAll(".reviews-navigation .nav-button").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var dir = btn.classList.contains("prev") ? -1 : 1;
          reviewsContainer.scrollBy({ left: dir * pasCarrousel(), behavior: "smooth" });
        });
      });
    }
  });
})();


/* ---------- Galerie produit : flèches + vignettes + swipe ---------- */
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    var main = document.querySelector("[data-gallery-main]");
    var thumbsWrap = document.querySelector("[data-gallery-thumbs]");
    if (!main) return;

    var slides = Array.prototype.slice.call(main.querySelectorAll(".pm-main-image"));
    var thumbs = thumbsWrap
      ? Array.prototype.slice.call(thumbsWrap.querySelectorAll(".pm-thumbnail"))
      : [];
    if (!slides.length) return;

    var current = Math.max(0, slides.findIndex(function (s) { return s.classList.contains("active"); }));

    /* ---------- Arrivee differee des visuels 2 a n ----------
       Les visuels suivants partent sans adresse (`data-src` / `data-srcset`,
       voir `product-main.liquid`). `loading="lazy"` ne suffisait pas : ils sont
       empiles au meme endroit que le premier, donc dans la fenetre, donc
       « visibles » pour le navigateur, qui les telechargeait tous — 369 Ko
       mesures le 29/08/2026 pour n en montrer qu un, en concurrence directe
       avec l image du LCP.

       On les pose des que la premiere image est arrivee : le chemin critique
       est libre, et la galerie est prete bien avant qu on puisse la faire
       defiler. Le <source>/srcset passe avant `src`, c est lui qui decide. */
    function hydrate(el) {
      if (!el || !el.getAttribute) return;
      var ss = el.getAttribute("data-srcset");
      if (ss) {
        el.srcset = ss;
        el.removeAttribute("data-srcset");
      }
      var src = el.getAttribute("data-src");
      if (src) {
        el.src = src;
        el.removeAttribute("data-src");
        el.removeAttribute("loading");
      }
    }

    function hydrateAll() {
      slides.forEach(hydrate);
    }

    /* 24/09/2026 : l ancien filet `requestIdleCallback(hydrateAll, 3000)`
       partait des que le navigateur soufflait — bien AVANT l arrivee du
       premier visuel sur un reseau lent — et relancait les 11 telechargements
       qu on voulait justement differer. Nouvelle regle : le visuel suivant des
       que le premier est la (pret pour un glissement), le reste apres
       l evenement load + un temps de repos, et tout de suite si la cliente
       touche la galerie. `show()` hydrate de toute facon le visuel demande. */
    (function scheduleHydration() {
      var first = slides[current];
      var done = false;
      function all() {
        if (done) return;
        done = true;
        hydrateAll();
      }
      function rest() {
        var go = function () {
          if (window.requestIdleCallback) window.requestIdleCallback(all, { timeout: 2000 });
          else setTimeout(all, 500);
        };
        if (document.readyState === "complete") go();
        else window.addEventListener("load", go, { once: true });
      }
      function firstArrived() {
        hydrate(slides[(current + 1) % slides.length]);
        rest();
      }
      [main, thumbsWrap].forEach(function (el) {
        if (el) el.addEventListener("pointerdown", all, { once: true, passive: true });
      });
      /* Deja arrivee (cache) ou pas une image : rien ne sert d attendre. */
      if (!first || first.tagName !== "IMG" || first.complete) {
        firstArrived();
        return;
      }
      first.addEventListener("load", firstArrived, { once: true });
      /* Une image en erreur ne doit pas retenir les autres en otage. */
      first.addEventListener("error", firstArrived, { once: true });
      /* Filet si aucun des deux evenements n arrive : on n attend pas indefiniment. */
      setTimeout(all, 10000);
    })();

    function show(i) {
      current = (i + slides.length) % slides.length;
      /* Filet : un clic tres precoce ne doit pas afficher un cadre vide. */
      hydrate(slides[current]);
      slides.forEach(function (s, k) {
        s.classList.toggle("active", k === current);
        /* Une video quittee continuerait a jouer, son compris, hors ecran. */
        if (k !== current && s.tagName === "VIDEO" && !s.paused) s.pause();
      });
      thumbs.forEach(function (t, k) {
        t.classList.toggle("active", k === current);
        /* La classe seule ne dit rien a un lecteur d ecran : aria-current
           annonce laquelle des vignettes est celle affichee. */
        t.setAttribute("aria-current", k === current ? "true" : "false");
      });
      var t = thumbs[current];
      if (t && t.scrollIntoView) {
        t.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
      }
    }

    var prev = document.querySelector("[data-gallery-prev]");
    var next = document.querySelector("[data-gallery-next]");
    if (prev) prev.addEventListener("click", function () { show(current - 1); });
    if (next) next.addEventListener("click", function () { show(current + 1); });

    /* Les vignettes sont des <div> : sans role ni tabindex, elles n existent
       ni pour le clavier ni pour un lecteur d ecran, alors qu elles sont le
       seul moyen d atteindre une image precise. On les equipe ici plutot que
       dans le Liquid — la galerie y est ecrite en dur dans plusieurs blocs,
       et un seul point de code les couvre tous. */
    thumbs.forEach(function (t, k) {
      t.setAttribute("role", "button");
      t.setAttribute("tabindex", "0");
      if (!t.getAttribute("aria-label")) {
        t.setAttribute("aria-label", "Voir l’image " + (k + 1) + " sur " + thumbs.length);
      }
      /* show() pose aria-current, mais il n est appele qu a la premiere
         interaction : sans cette ligne, un lecteur d ecran qui arrive sur la
         page ne sait pas quelle vignette est deja affichee. */
      t.setAttribute("aria-current", k === current ? "true" : "false");
      t.addEventListener("click", function () { show(k); });
      t.addEventListener("keydown", function (e) {
        /* « Spacebar » : libelle des vieux Edge/IE, encore croise sur mobile. */
        if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
          e.preventDefault();
          show(k);
        }
      });
    });

    /* Swipe tactile */
    var startX = null;
    main.addEventListener("touchstart", function (e) {
      /* Le doigt peut partir a gauche comme a droite : on pose tout. */
      hydrateAll();
      startX = e.touches[0].clientX;
    }, { passive: true });
    main.addEventListener("touchend", function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(dx < 0 ? current + 1 : current - 1);
      startX = null;
    }, { passive: true });

    /* Clavier */
    main.setAttribute("tabindex", "0");
    main.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") show(current - 1);
      if (e.key === "ArrowRight") show(current + 1);
    });
  });
})();

/* ---------- Barre d'achat fixe (mobile) ---------- */
(function () {
  var bar = document.querySelector("[data-sticky-atc]");
  if (!bar) return;

  var priceEl = bar.querySelector("[data-sticky-price]");
  var mainBtn = document.querySelector(".pm-atc-wrapper .pm-atc-button");

  /* Le prix suit le palier coche : sinon la barre annoncerait un montant faux. */
  var compareEl = bar.querySelector("[data-sticky-compare]");

  /* La barre reprend le prix du palier réellement sélectionné. */
  function syncPrice() {
    var selectedInput = document.querySelector("[data-bundle] .pm-bundle-input:checked");
    var selectedBar = selectedInput && selectedInput.closest("[data-bundle-bar]");
    if (!selectedBar || !priceEl) return;
    var price = selectedBar.querySelector("[data-bundle-price]");
    if (price) priceEl.textContent = price.textContent.trim();
    if (!compareEl) return;
    var compare = selectedBar.querySelector("[data-bundle-compare]");
    if (compare) {
      compareEl.textContent = compare.textContent.trim();
      compareEl.hidden = false;
    } else {
      compareEl.hidden = true;
    }
  }
  syncPrice();

  /* La visibilite est RECALCULEE a chaque scroll, pas deduite des transitions
     d un IntersectionObserver. Un IO ne rappelle que sur changement d etat :
     si le doigt lance la page assez vite pour que le bouton principal traverse
     l ecran entre deux frames, l etat « hors ecran » ne change jamais, aucun
     callback ne part, et la barre restait morte pour le reste de la visite.
     Sur mobile le fling EST le mode de scroll par defaut — mesure le
     26/08/2026 : saut direct 0 -> 2400 px, barre absente. */
  if (!mainBtn) {
    bar.classList.add("is-visible");
    return;
  }

  var footer = document.querySelector("footer");
  var petitEcran = window.matchMedia("(max-width: 768px)");

  function refresh() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var btn = mainBtn.getBoundingClientRect();

    /* Deux CTA a l ecran en meme temps se cannibalisent : tant que le bouton
       principal est visible, la barre s efface. */
    var btnVisible = btn.top < vh && btn.bottom > 0;

    /* Le pied de page porte les mentions legales : la carte flottante ne doit
       pas les recouvrir. */
    var atFooter = false;
    if (footer) {
      var f = footer.getBoundingClientRect();
      atFooter = f.top < vh && f.bottom > 0;
    }

    /* Sous 768px le prix n apparait qu a 1 046 px et le CTA a 1 491 px, soit
       plus de deux ecrans de scroll avant de savoir combien ca coute. La barre
       porte deja le prix et un « AJOUTER » : on l affiche des le chargement.
       Au-dessus de 768px on garde le comportement d origine — elle n arrive
       qu une fois le bouton principal depasse. */
    var voulue = petitEcran.matches ? true : btn.bottom <= 0;

    bar.classList.toggle("is-visible", voulue && !btnVisible && !atFooter);
  }

  /* rAF : le handler ne tourne qu une fois par frame rendue, meme si le
     navigateur emet cinquante evenements de scroll par seconde. */
  var enAttente = false;
  function planifier() {
    if (enAttente) return;
    enAttente = true;
    window.requestAnimationFrame(function () {
      enAttente = false;
      refresh();
    });
  }

  window.addEventListener("scroll", planifier, { passive: true });
  window.addEventListener("resize", planifier);
  window.addEventListener("orientationchange", planifier);
  if (petitEcran.addEventListener) petitEcran.addEventListener("change", planifier);
  refresh();
})();

/* ---------- Compte a rebours du bloc de chauffe ---------- */
/* La fenetre est propre au visiteur : sa fin est ecrite dans localStorage, donc
   elle ne repart pas de zero a chaque rechargement de la page. Quand elle est
   epuisee, une nouvelle fenetre demarre au chargement suivant. */
/* querySelectorAll et non querySelector : la page porte deux horloges — celle
   du bandeau d offre, en haut des paliers, et celle du bloc de chauffe plus
   bas. Avec querySelector la seconde restait figee sur « --:--:-- ». Les deux
   lisent la MEME echeance en localStorage, donc elles ne peuvent pas afficher
   deux heures differentes pour une seule et meme offre. */
(function () {
  var els = document.querySelectorAll("[data-stock-countdown]");
  if (!els.length) return;

  var KEY = "kaela:offer-deadline";
  var hours = parseFloat(els[0].getAttribute("data-countdown-hours")) || 4.5;
  var span = hours * 3600 * 1000;

  var deadline = parseInt(window.localStorage ? localStorage.getItem(KEY) : 0, 10);
  if (!deadline || isNaN(deadline) || deadline - Date.now() <= 0 || deadline - Date.now() > span) {
    deadline = Date.now() + span;
    try { localStorage.setItem(KEY, String(deadline)); } catch (e) {}
  }

  function pad(n) { return n < 10 ? "0" + n : String(n); }

  function tick() {
    var left = Math.max(0, deadline - Date.now());
    var s = Math.floor(left / 1000);
    var h = Math.floor(s / 3600), m = Math.floor(s / 60) % 60, sec = s % 60;
    for (var i = 0; i < els.length; i++) {
      /* data-countdown-format="hm" -> « 13 : 49 » (bandeau), sinon hh:mm:ss */
      els[i].textContent = els[i].getAttribute("data-countdown-format") === "hm"
        ? pad(h) + " : " + pad(m)
        : pad(h) + ":" + pad(m) + ":" + pad(sec);
      els[i].setAttribute("datetime", "PT" + h + "H" + m + "M" + sec + "S");
    }
    if (left <= 0) clearInterval(timer);
  }

  tick();
  var timer = setInterval(tick, 1000);
})();
